import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { create } from './orientation';
export default {
  name: 'VftScreenOrientation',
  props: {
    support: {
      type: String,
      default: 'portrait',
      validator: function validator(value) {
        return ['landscape', 'portrait', 'all'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      orientation: ''
    };
  },
  created: function created() {
    var _this = this;

    var detector = create();
    this.orientation = detector.orientation;
    detector.onChange(function (orientation) {
      _this.orientation = orientation;
      return orientation;
    });
  },
  computed: {
    isSupport: function isSupport() {
      if (!this.support) {
        return this.orientation === 'portrait';
      }

      if (this.support === 'all') {
        return true;
      }

      return this.support === this.orientation;
    }
  }
};